// @flow

import { type LookAndFeel } from '@tectonics/look-and-feel';

const uber: LookAndFeel = {
  code: 'uber',
  displayName: 'Uber',
  getRootComponent: () => import('./uber'),
  getLoadingPage: () => import('@tectonics/components/loading-page'),
  prsSupport: {
    integrations: {
      br: ['boleto', 'banktransfer', 'pix', 'vouchercard'],
      mx: ['cash', 'spei', 'oxxopay'],
      co: ['eft', 'cash', 'externalpayprovider'],
      cl: ['multicaja', 'sencillito', 'servipag', 'webpay', 'ewallet'],
      pe: ['safetypay', 'pagoefectivo'],
      ec: ['safetypay-cash', 'safetypay-online'],
      ar: ['cash', 'ewallet'],
      bo: ['cash'],
      uy: ['ewallet'],
    },
    features: [
      { name: 'display_merchant_logo' },
      { name: 'display_receipt_original_amount' },
      { name: 'display_receipt_fx_rate' },
      { name: 'display_receipt_brazilian_tax_iof' },
      { name: 'display_receipt_final_amount' },

      { name: 'field_customer_email' },
      { name: 'field_customer_name' },

      { name: 'field_brazilian_document', traits: ['type_cpf', 'type_cnpj'] },

      { name: 'field_colombian_document' },
      { name: 'field_colombian_document_type' },
      { name: 'field_colombian_phone_number' },
      { name: 'field_colombian_bank_list' },
      { name: 'field_colombian_address' },
      { name: 'field_colombian_externalpayprovider_bank_list' },

      { name: 'field_chilean_document' },
      { name: 'field_chilean_phone_number' },

      { name: 'field_peruvian_phone_number' },

      { name: 'field_ecuadorian_phone_number' },

      { name: 'field_mexican_phone_number' },

      { name: 'field_bolivian_phone_number' },

      { name: 'field_argentine_phone_number' },

      { name: 'display_boleto_total_value' },
      { name: 'display_boleto_due_date' },
      { name: 'display_boleto_barcode' },
      { name: 'display_boleto_number' },
      { name: 'display_boleto_email_warning' },
      { name: 'display_boleto_tips' },
      { name: 'action_boleto_copy_code' },
      { name: 'action_boleto_save_pdf' },

      { name: 'action_cash_save_pdf' },
      { name: 'display_cash_barcode' },
      { name: 'display_cash_due_date' },
      { name: 'display_cash_instructions' },
      { name: 'display_cash_number' },
      { name: 'display_cash_tips' },
      { name: 'display_cash_total_value' },

      { name: 'display_spei_total_amount' },
      { name: 'display_spei_due_date' },
      { name: 'display_spei_destination_clabe_number' },
      { name: 'display_spei_reference_number' },
      { name: 'display_spei_destination_bank' },
      { name: 'display_spei_destination_beneficiary' },
      { name: 'action_spei_save_pdf' },
      { name: 'display_spei_instructions' },

      { name: 'display_pagoefectivo_total_value' },
      { name: 'display_pagoefectivo_due_date' },
      { name: 'display_pagoefectivo_cip_code' },
      { name: 'action_pagoefectivo_save_cip_as_pdf' },
      { name: 'display_pagoefectivo_instructions' },

      { name: 'display_pagosnet_total_value' },
      { name: 'display_pagosnet_due_date' },

      { name: 'display_vr_display_name' },
      { name: 'field_vr_pre_tokenized_card_cvv' },
    ],
  },
};

export default uber;
